import { render } from "./Notification.vue?vue&type=template&id=6a12973e&scoped=true&ts=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=6a12973e&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12973e"]])

export default __exports__